import createState from '@/store/model/state'
const state = createState()

export default state
